import axios from "axios";

const API_BASE_URL = "https://api.haj.kz/api/v1";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Интерцептор для запросов
apiClient.interceptors.request.use(
  (config) => {
    // Здесь можно добавить токен авторизации если нужно
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для ответов
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Обработка ошибок (например, истекший токен)
    if (error.response && error.response.status === 401) {
      // Можно добавить редирект на страницу логина
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
